var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.inner},[_c('span',{class:_vm.$style.logo}),_c('div',{class:_vm.$style.search},[_vm._v("\n      Поиск\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }